import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getBrandFaqs, GetBrandFaqsApiParameter, FaqModel, FaqCollectionModel } from "@tCentro/Services/CENBrandFAQService";
import { CatFaqCollectionModel, getCatFaqs, GetCatFaqsApiParameter } from "@tCentro/Services/CENCatFAQService";


type Parameter =
    GetCatFaqsApiParameter &
    HasOnSuccess<CatFaqCollectionModel>;
type Props = {
    apiParameter: GetCatFaqsApiParameter;
    apiResult: CatFaqCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadBrandFaqs: HandlerType = props => {
    props.dispatch({
        type: "Custom/FaqData/BeginCatLoad",
        categoryId: props.parameter.categoryId,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCatFaqs(props.apiParameter);
    } catch (error) {
        if (error?.status === 404) {
            props.dispatch({
                type: "Custom/Faq/CompletedCatLoad",
                categoryId: props.apiParameter.categoryId,
                result: [],
            });
            return false;
        }
        throw error;
    }
};


export const DispatchCompleteLoadBrandFaqs: HandlerType = props => {
    props.dispatch({
        type: "Custom/Faq/CompletedCatLoad",
        categoryId: props.apiParameter.categoryId,
        result: props.apiResult.faqs ?? [],
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginLoadBrandFaqs,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadBrandFaqs,
    ExecuteOnSuccessCallback,
];

const loadCatFaqs = createHandlerChainRunner(chain, "LoadCatFaqs");
export default loadCatFaqs;
 